import { routeProductMap } from 'utils/product/configs'
import { toCamelCase } from 'utils/stringHelpers'

const determineProductMap = name => {
  return routeProductMap[toCamelCase(name)]
}

export default {
  determineProductMap,
}
